import api from '@anm/api';
import { UploadNameSpace } from '@anm/api/modules/uploads';
import getExtensionFromPath from '@anm/helpers/getExtensionFromPath';
import { AxiosProgressEvent } from 'axios';

type GetUploadDataProps = {
  file: File | null;
  nameSpace?: UploadNameSpace;
  folderPath?: string;
  simpleUpload?: boolean;
  onUploadProgress?: (event: AxiosProgressEvent) => void;
};

const createUpload = async ({ file, nameSpace, folderPath, simpleUpload, onUploadProgress }: GetUploadDataProps) => {
  if (!file) return;

  const extension = getExtensionFromPath(file.name) || '';

  const { request, data } = await api().uploads.createUpload({
    extension,
    nameSpace,
    simpleUpload,
    isEmbedded: false,
    projectType: 'upload',
    folderPath: folderPath || '/',
    meta: {
      name: file.name,
      size: file.size
    }
  });

  await api().uploads.uploadFile({
    file,
    url: request.url,
    method: request.method,
    onUploadProgress
  });

  const uploadId = data.upload.id;

  return uploadId;
};

export default createUpload;
